import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GetOrderForCheckoutQuery } from '../../common/generated-types';
import { DataService } from '../../core/providers/data/data.service';
import { StateService } from '../../core/providers/state/state.service';
import { CheckoutConfirmationComponent } from '../components/checkout-confirmation/checkout-confirmation.component';
import { CheckoutPaymentComponent } from '../components/checkout-payment/checkout-payment.component';
import { CheckoutShippingComponent } from '../components/checkout-shipping/checkout-shipping.component';
import { CheckoutSignInComponent } from '../components/checkout-sign-in/checkout-sign-in.component';

import { GET_ORDER_FOR_CHECKOUT } from './checkout-resolver.graphql';
import { CHECKOUT_ROUTES } from '../checkout.routes';

@Injectable({ providedIn: 'root' })
export class CheckoutGuard  {

    constructor(private router: Router,
                private dataService: DataService,
                private stateService: StateService) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const orderState$ = this.dataService.query<GetOrderForCheckoutQuery>(GET_ORDER_FOR_CHECKOUT, undefined, 'cache-first').pipe(
            map(data => data.activeOrder ? data.activeOrder.state : 'AddingItems'),
        );
        const signedIn$ = this.stateService.select(state => state.signedIn);
        return combineLatest(orderState$, signedIn$).pipe(
            map(([, signedIn]) => {
                const component = route.component;

                if (component === CheckoutSignInComponent) {
                    if (signedIn) {
                        this.router.navigate(['/', CHECKOUT_ROUTES.CHECKOUT, CHECKOUT_ROUTES.PAYMENT]);
                        return false;
                    } else {
                       
                        this.router.navigate(['/', CHECKOUT_ROUTES.CHECKOUT, CHECKOUT_ROUTES.PAYMENT]);
                        return false;
                    }
                } else if (component === CheckoutShippingComponent) {
                    this.router.navigate(['/', CHECKOUT_ROUTES.CHECKOUT, CHECKOUT_ROUTES.PAYMENT]);
                    return false;
                } else if (component === CheckoutPaymentComponent) {
                    return true;
                } else if (component === CheckoutConfirmationComponent) {
                    return true;
                }

                return true;
            }),
        );
    }
}
